<template>
  <div class="signing-page">
    <nav-bar
      fixed
      z-index="99"
      title="用户签约"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div style="height: 46px"></div>
    
    <div class="form-container">
      <van-form @submit="onSubmit">
        <van-field
          v-model="formData.realName"
          name="realName"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="formData.phone"
          name="phone"
          label="手机号"
          placeholder="请输入手机号"
          readonly
          :rules="[
            { required: true, message: '请填写手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]"
        />
        <van-field
          v-model="formData.cardId"
          name="cardId"
          label="身份证号"
          placeholder="请输入身份证号"
          :rules="[
            { required: true, message: '请填写身份证号' },
            { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号' }
          ]"
        />
        <van-field
          v-model="formData.address"
          name="address"
          label="联系地址"
          placeholder="请输入居住/联系地址"
          :rules="[{ required: true, message: '请填写联系地址' }]"
        />
        
        <!-- 在按钮上方添加签约说明 -->
        <div class="instruction-container" v-if="signingInstructions">
          <div class="instruction-title">签约说明</div>
          <div class="instruction-content" v-html="signingInstructions"></div>
        </div>
        
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit" :loading="loading">
            确认签约
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { NavBar, Field, Form, Button, Toast, Dialog } from "vant";
import { recruitOne, getUserInfo } from "@api/user";
import { mapMutations, mapState } from "vuex";
import { getLcSystemConfig } from "@api/public"; // 导入新的系统配置接口

export default {
  name: "UserSigning",
  components: {
    NavBar,
    VanField: Field,
    VanForm: Form,
    VanButton: Button
  },
  computed: {
    ...mapState({
      storePhone: state => state.app.phone
    })
  },
  data() {
    return {
      loading: false,
      formData: {
        realName: "",
        phone: "",
        cardId: "",
        address: ""
      },
      signingInstructions: "" // 存储签约说明内容
    };
  },
  created() {
    // 初始化表单手机号为store中存储的值
    if (this.storePhone && this.storePhone !== 0) {
      this.formData.phone = this.storePhone;
    }
    
    // 获取当前用户信息并预填已有资料
    getUserInfo().then(res => {
      if (res.data) {
        if (!this.formData.phone && res.data.phone) {
          this.formData.phone = res.data.phone;
        }
        if (res.data.realName) {
          this.formData.realName = res.data.realName;
        }
        if (res.data.cardId) {
          this.formData.cardId = res.data.cardId;
        }
        if (res.data.addres) {
          this.formData.address = res.data.addres;
        }
      }
    }).catch(() => {});

    // 获取签约说明
    this.getSigningInstructions();
  },
  methods: {
    ...mapMutations(["SET_USER"]),
    
    // 获取签约说明内容
    getSigningInstructions() {
      getLcSystemConfig().then(res => {
        if (res.status === 200 && res.data && res.data.content) {
          const configData = res.data.content;
          // 查找签约说明配置项
          const signingInstructionsConfig = configData.find(item => item.menuName === 'signing_instructions');
          if (signingInstructionsConfig) {
            this.signingInstructions = signingInstructionsConfig.value;
          }
        }
      }).catch(error => {
        console.error('获取签约说明失败:', error);
      });
    },
    
    onSubmit() {
      this.loading = true;

      // 获取当前用户信息
      getUserInfo().then(res => {
        const userInfo = res.data;

        // 构造完整的签约数据结构，匹配后端API期望的格式
        const recruitData = {
          addIp: userInfo.addIp || "",
          addres: this.formData.address || userInfo.addres || "",
          adminid: userInfo.adminid || 0,
          avatar: userInfo.avatar || "",
          birthday: userInfo.birthday || 0,
          brokeragePrice: 0.00,
          cardId: this.formData.cardId,
          commentNumber: userInfo.commentNumber || 0,
          createTime:userInfo.createTime || "",
          email: userInfo.email || "",
          freeFirstNum: userInfo.freeFirstNum || 0,
          groupId: userInfo.groupId || 0,
          integral: 0.00,
          isFirst: userInfo.isFirst || 0,
          isPromoter: userInfo.isPromoter || 0,
          isSign: userInfo.isSign || 0,
          level: userInfo.level || 0,
          loginType: userInfo.loginType || "",
          mark: userInfo.mark || "",
          nickname: userInfo.nickname || "",
          nowMoney: 0.00,
          partnerId: userInfo.partnerId || 0,
          password: userInfo.password || "",
          payCount: userInfo.payCount || 0,
          payFirstNum:userInfo.payFirstNum || 0,
          payNum: userInfo.payNum || 0,
          phone: userInfo.phone || "",
          realName: userInfo.realName || "",
          signName: this.formData.realName,
          signNum: 0,
          signPhone: this.formData.phone,
          spreadCount: userInfo.spreadCount || 0,
          spreadTime: "",
          spreadUid: userInfo.spreadUid || 0,
          status: userInfo.status ? 1 : 0,
          totalConsumption: 0.00,
          uid: userInfo.uid || 0,
          userCategory: userInfo.userCategory || "",
          userType: userInfo.userType || "",
          username: userInfo.username || "",
          wechatNumber: userInfo.wechatNumber || "",
          welfareNum: userInfo.welfareNum || 0
        };

        // 使用封装好的API方法
        recruitOne(recruitData)
          .then(res => {
            this.loading = false;
            
            if (res.status === 200) {
              const signUrl = res.data;
              // 场景 2：需要前往签署电子合同（后端返回比安 H5 签约链接）
              if (signUrl && typeof signUrl === "string" && (signUrl.indexOf("http://") === 0 || signUrl.indexOf("https://") === 0)) {
                Dialog.alert({
                  title: "签约协议签署",
                  message: res.msg || "根据灵工合规要求，请前往比安平台完成实名协议签署",
                  confirmButtonText: "前往签署"
                }).then(() => {
                  window.location.href = signUrl;
                });
              } else {
                // 场景 1：已直接签约成功
                Toast.success(res.msg || "签约成功");

                // 更新用户信息，设置isSign=1
                const updatedUserInfo = {
                  ...userInfo,
                  isSign: 1
                };
                this.SET_USER(updatedUserInfo);

                // 返回到推广页面
                setTimeout(() => {
                  this.$router.push("/user/user_promotion");
                }, 1500);
              }
            } else {
              // 处理特定错误码
              if (res.status === 5101) {
                Toast.fail(res.msg);
              } else {
                Toast.fail(res.msg);
              }
            }
          })
          .catch(err => {
            this.loading = false;
            console.error('签约请求错误:', err);
            
            // 增加对特定错误码的处理
            if (err.status === 5101) {
              Toast.fail(err.msg);
            } else {
              Toast.fail(err.msg);
            }
          });
      }).catch(err => {
        this.loading = false;
        Toast.fail(err.msg || "获取用户信息失败，请稍后重试");
      });
    }
  }
};
</script>

<style scoped>
.signing-page {
  background-color: #f8f8f8;
  min-height: 100vh;
}
.form-container {
  background-color: #fff;
  padding: 20px 0;
  margin-top: 10px;
}
.instruction-container {
  background-color: #fff;
  padding: 15px;
  margin-top: 10px;
}
.instruction-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}
.instruction-content {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
}
</style>
